export class GetBorrowerOpportunityHistory {
	static readonly type = '[BorrowerOpportunityHistory] GetBorrowerOpportunityHistory';
	constructor(public borrowerId: number) {}
}
export class ClearBorrowerOpportunityHistory {
	static readonly type = '[BorrowerOpportunityHistory] ClearBorrowerOpportunityHistory';
	constructor() {}
}
